"use strict";
const UUID = (function () {
    const byteToHex = [];
    for (let i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 0x100).toString(16).substr(1);
    }
    function bytesToUuid(buf, offset) {
        let i = offset || 0;
        const bth = byteToHex;
        return [
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
            '-',
            bth[buf[i++]],
            bth[buf[i++]],
            '-',
            bth[buf[i++]],
            bth[buf[i++]],
            '-',
            bth[buf[i++]],
            bth[buf[i++]],
            '-',
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
            bth[buf[i++]],
        ].join('');
    }
    const createRandomValues = (function () {
        const getRandomValues = (typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
            (typeof msCrypto != 'undefined' &&
                typeof window.msCrypto.getRandomValues == 'function' &&
                msCrypto.getRandomValues.bind(msCrypto));
        if (getRandomValues) {
            const rnds8 = new Uint8Array(16);
            return function whatwgRNG() {
                getRandomValues(rnds8);
                return rnds8;
            };
        }
        else {
            const rnds = new Array(16);
            return function mathRNG() {
                for (let i = 0, r; i < 16; i++) {
                    if ((i & 0x03) === 0) {
                        r = Math.random() * 0x100000000;
                    }
                    rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
                }
                return rnds;
            };
        }
    })();
    return function UUID_() {
        const rnds = createRandomValues();
        rnds[6] = (rnds[6] & 0x0f) | 0x40;
        rnds[8] = (rnds[8] & 0x3f) | 0x80;
        return bytesToUuid(rnds);
    };
})();
const IT_IS_A_WEB_WORKER = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
const KEYS_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const CROSSCHECK_EVENT_OVER_ALT_DOMAIN = 'dashboard_loaded';
const MAIN_ORIGIN = 'track.miro.com';
const ALTERNATIVE_ORIGIN = 'jrigwqfdrha847.miro.com';
const ALT_DOMAIN_EVENT_SUFFIX = '_over_new_domain';
function getEventProps(params, writeKey) {
    const uuid = UUID();
    const sentAt = new Date();
    const properties = {
        sentAt: sentAt,
        timestamp: sentAt,
        context: {
            app: params.context.app,
            library: {
                group: params.context.library.group,
                name: params.context.library.name,
                version: params.context.library.version,
            },
            page: {
                referrer: params.context.page.referrer,
                path: params.context.page.path,
                search: params.context.page.search,
                title: params.context.page.title,
                url: params.context.page.url,
                inIframe: params.context.page.inIframe,
                language: params.context.page.language,
            },
            userAgent: params.context.userAgent,
            sessionId: params.context.sessionId,
        },
        messageId: 'ajs-' + uuid.replace(/-/g, ''),
        event: undefined,
        properties: undefined,
        traits: undefined,
        writeKey: writeKey,
        anonymousId: params.anonymousId,
        userId: params.userId ? params.userId : undefined,
    };
    return properties;
}
function identify(params) {
    const url = params.apiHost + '/i';
    const properties = getEventProps(params, params.apiKey);
    properties.type = 'identify';
    properties.traits = {
        name: params.user.name,
        email: params.user.email,
    };
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'text/plain');
    xhr.send(JSON.stringify(properties));
}
function page(params) {
    const url = params.apiHost + '/p';
    const properties = getEventProps(params, params.apiKey);
    properties.type = 'page';
    if (params.timestamp) {
        properties.timestamp = params.timestamp;
    }
    properties.properties = {
        language: params.context.page.language,
        referrer: params.context.page.referrer,
        path: params.context.page.path,
        search: params.context.page.search,
        title: params.context.page.title,
        url: params.context.page.url,
        utm_campaign: params.properties?.utm_campaign,
        utm_content: params.properties?.utm_content,
        utm_custom: params.properties?.utm_custom,
        utm_medium: params.properties?.utm_medium,
        utm_source: params.properties?.utm_source,
        utm_term: params.properties?.utm_term,
    };
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'text/plain');
    xhr.send(JSON.stringify(properties));
}
function copyTypedArrayToRegularArray(typedArray, length) {
    const result = new Array(length);
    for (let i = 0; i < length; i++) {
        result[i] = typedArray[i];
    }
    return result;
}
function extractTransferableItems(properties) {
    if (properties.__bufferData) {
        const bufferData = properties.__bufferData;
        delete properties.__bufferData;
        try {
            bufferData.items.forEach(function (transferItem) {
                let value = undefined;
                switch (transferItem.type) {
                    case 'Uint32Array':
                        {
                            const arr = new Uint32Array(transferItem.buffer);
                            value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
                        }
                        break;
                    case 'Int32Array':
                        {
                            const arr = new Int32Array(transferItem.buffer);
                            value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
                        }
                        break;
                    case 'Float32Array':
                        {
                            const arr = new Float32Array(transferItem.buffer);
                            value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
                        }
                        break;
                    default:
                        {
                            value = undefined;
                            console.error('Transferable type is not supported: ', transferItem.type);
                        }
                        break;
                }
                if (value) {
                    properties[transferItem.name] = value;
                }
            });
        }
        catch (e) {
            console.error('Transferable error', e);
        }
    }
}
const trackOverAlternativeDomain = params => {
    params.apiHost = params.apiHost.replace(MAIN_ORIGIN, ALTERNATIVE_ORIGIN);
    params.event = `${params.event}${ALT_DOMAIN_EVENT_SUFFIX}`;
    const url = params.apiHost + '/t';
    const body = buildTrackProperties(params, params.apiKey);
    sendWithRetry(url, {
        headers: {
            'Content-Type': 'text/plain',
        },
        body,
        retryOptions: {
            maxRetries: 1,
        },
    });
};
function track(params) {
    const url = params.apiHost + '/t';
    const body = buildTrackProperties(params, params.apiKey);
    sendWithRetry(url, {
        headers: {
            'Content-Type': 'text/plain',
        },
        body,
        retryOptions: {
            maxRetries: 1,
        },
    });
    if (params.event === CROSSCHECK_EVENT_OVER_ALT_DOMAIN) {
        trackOverAlternativeDomain({ ...params });
    }
}
function buildTrackProperties(params, apiKey) {
    const properties = getEventProps(params, apiKey);
    properties.type = 'track';
    properties.event = params.event;
    if (params.timestamp) {
        properties.timestamp = params.timestamp;
    }
    extractTransferableItems(params.properties);
    properties.properties = params.properties;
    if (params.timestamp > properties.sentAt) {
        properties.sentAt = params.timestamp;
    }
    return properties;
}
function getBatchRequestPayload(params) {
    const url = params.apiHost + '/import';
    const batch = params.tracks.map(trackParams => buildTrackProperties(trackParams, undefined));
    return {
        url,
        body: {
            batch: batch,
            writeKey: params.apiKey,
        },
    };
}
function trackBatch(params) {
    const { url, body } = getBatchRequestPayload(params);
    sendWithRetry(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        body,
        retryOptions: {
            retryTimeout: 3000,
        },
    });
}
function trySendRequestWithBeacon(params) {
    try {
        const { url, body } = getBatchRequestPayload(params);
        return navigator.sendBeacon(url, JSON.stringify(body));
    }
    catch {
        return false;
    }
}
function trackBatchWithBeacon(params) {
    if (!trySendRequestWithBeacon(params)) {
        trackBatch(params);
    }
}
const METHODS_CONTAINER = {
    identify: identify,
    track: track,
    page: page,
    trackBatch: trackBatch,
    trackBatchWithBeacon: trackBatchWithBeacon,
};
function processWorkerMessage(data) {
    const event = data.event;
    const payload = data.payload;
    switch (event) {
        case 'identify':
            {
                METHODS_CONTAINER.identify(payload);
            }
            break;
        case 'track':
            {
                METHODS_CONTAINER.track(payload);
            }
            break;
        case 'trackBatch':
            {
                METHODS_CONTAINER.trackBatch(payload);
            }
            break;
        default: {
            console.error('Unknown event', data.event, data);
        }
    }
}
if (IT_IS_A_WEB_WORKER) {
    addEventListener('message', function (event) {
        const data = event.data;
        processWorkerMessage(data);
    });
    postMessage('ready');
}
else {
    module.exports.UUID = UUID;
    module.exports.identify = identify;
    module.exports.track = track;
    module.exports.page = page;
    module.exports.trackBatch = trackBatch;
    module.exports.trackBatchWithBeacon = trackBatchWithBeacon;
    module.exports.__stringToBase64 = stringToBase64;
    module.exports.__processWorkerMessage = processWorkerMessage;
    module.exports.__METHODS_CONTAINER = METHODS_CONTAINER;
}
function stringToBase64(input) {
    let output = '';
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = utf8Encode(input);
    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output + KEYS_STR.charAt(enc1) + KEYS_STR.charAt(enc2) + KEYS_STR.charAt(enc3) + KEYS_STR.charAt(enc4);
    }
    return output;
}
function utf8Encode(string) {
    string = string.replace(/\r\n/g, '\n');
    let utftext = '';
    for (let n = 0; n < string.length; n++) {
        const c = string.charCodeAt(n);
        if (c < 128) {
            utftext += String.fromCharCode(c);
        }
        else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
        }
        else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
        }
    }
    return utftext;
}
const DEFAULT_RETRY_OPTIONS = {
    maxRetries: 3,
    retryTimeout: 1000,
    increaseTimeoutFactor: 1,
    maxRetryTimeout: 5000,
};
const sendWithRetry = (url, params) => {
    const request = new XMLHttpRequest();
    const { method = 'POST', headers = {}, body } = params;
    const retryOptions = { ...DEFAULT_RETRY_OPTIONS, ...(params.retryOptions || {}) };
    const { retryTimeout, maxRetries, increaseTimeoutFactor, maxRetryTimeout } = retryOptions;
    const payload = body ? JSON.stringify(body) : undefined;
    let retryAttempt = 0;
    const openAndSend = () => {
        request.open(method, url, true);
        for (const [headerName, headerValue] of Object.entries(headers)) {
            request.setRequestHeader(headerName, headerValue);
        }
        request.send(payload);
    };
    const retry = () => {
        const timeout = retryAttempt > 1 ? retryAttempt * retryTimeout * increaseTimeoutFactor : retryTimeout;
        setTimeout(openAndSend, Math.min(timeout, maxRetryTimeout));
    };
    const checkStatusAndRetry = () => {
        const shouldRetryOnStatus = request.status >= 400 || request.status === 0;
        if (shouldRetryOnStatus && retryAttempt < maxRetries) {
            retryAttempt++;
            retry();
        }
    };
    request.onerror = checkStatusAndRetry;
    request.ontimeout = checkStatusAndRetry;
    request.onload = checkStatusAndRetry;
    openAndSend();
};
